<template>
  <article class="post-entry">
    <header class="entry-header">
      <h3 class="entry-hint-parent">{{data.title}}
        <span class="entry-hint" title="Draft">
          <svg fill="none" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" viewBox="0 0 24 24" height="12" width="12">
            <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"></path>
            <path d="M15 3h6v6"></path>
            <path d="M10 14L21 3"></path>
          </svg>
        </span>
      </h3>
    </header>
    <div class="entry-content">
      <p>Posted on: {{new Date(data.pubDate).toDateString()}}</p>
    </div>
    <footer class="entry-footer">
      <span title='2021-01-20 00:00:00 +0000 UTC'>Categories: {{categories}} </span>
    </footer>
    <a class="entry-link" aria-label="post link to Variables | Front Matter" :href="data.link" target="_blank"></a>
  </article>
</template>
<script>
export default {
  name: 'Post',
  props: ['data'],
  computed: {
    categories() {
      return this.data.categories.join(', ')
    }
  }
}
</script>
